module.exports = __webpack_public_path__ + "static/media/studio_electric_forklift_truck_me_316_manitou_008.de717324.png";